import type { CustomQueryParams } from '@/services/router-proxy/types';
import { type Manifest, type RouterConfig, PAGE_TYPE } from '@/types/manifest';

export const DESIGN_FTO_FLOW_ROUTER_NAME = 'design-fto-flow';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.PAGE,
    name: DESIGN_FTO_FLOW_ROUTER_NAME,
    exclusiveRoutePath: '/design-fto/:task_id',
    getComponent: () => {
        return import('./DesignFtoFlow.vue');
    },
};

export const manifest: Manifest = {
    ...routerConfig,
};

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 去到外观防侵权检索页面
         * @param commandId - 命令(去到外观防侵权检索页面)
         * @param params - 参数(包含任务 ID)
         */
        executeCommand(commandId: 'command:route:design-fto:flow', params?: CustomQueryParams): void;
    }
}
